module.exports = __webpack_public_path__ + "static/media/b1.ab34690.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sangwenfeng/b1.mp3
// module id = z7iO
// module chunks = 0